import React from "react";
import "./HeaderSub.css";
import { Navbar, Nav } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router-dom";

export default () => {
  return (
    <div className="header-new float-left w-100">
      <Navbar expand="lg" fixed="top">
        <Navbar.Brand href="/">
          <img src={require("../../assets/images/logo.png")} />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            <NavLink to="/become-a-tutor/overview" className="nav-link" activeClassName="nav-link active">Overview</NavLink>
            <NavLink to="/become-a-tutor/setup" className="nav-link" activeClassName="nav-link active">Setup</NavLink>
            <NavLink to="/become-a-tutor/earnings" className="nav-link" activeClassName="nav-link active">Earnings</NavLink>
            <NavLink to="/become-a-tutor/stories" className="nav-link" activeClassName="nav-link active">Tutoring Services</NavLink>
          </Nav>
          <div className="nav-right">
            <label>
              Montly £ 1200 <FontAwesomeIcon icon={faInfoCircle} />
            </label>
            <a href="#">Get Started</a>
          </div>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};
